export function clearAllBut(excluded: string[]): void {
    const keys = Object.keys(localStorage);
    keys.map((key) => {
        if (excluded.indexOf(key) === -1) {
            localStorage.removeItem(key);
        }
    });
}